// extracted by mini-css-extract-plugin
export default {"page":"Page_page__FMSn7","header":"Page_header__scQjf","title":"Page_title__81vey","extra":"Page_extra__f3+CL","body":"Page_body__ACQi9"};